export const headerTyps = [
  { id: 'sales', name: '매출액' },
  { id: 'purchase', name: '매입액' },
  { id: 'profitPrice', name: '매출이익' },
  { id: 'profit', name: '이익률' },
];

export const prjHeaders = [
  { id: 'HM', name: '(H+M)', val: 'HM' },
  { id: 'L', name: '(L)', val: 'L' },
  //  { id: 'HML', name: '(H+M+L)', val: 'HML' },
  { id: 'F', name: '(F)', val: 'F' },
];

export const prjDeptHeaders = [
  { id: 'ES', name: '예상 포캐스팅', val: 'ES' }, //ESTIMATE SALES
  { id: 'OA', name: '수주금액', val: 'OA' }, //Order amount
  { id: 'HM', name: 'H+M', val: 'HM' },
];

export const prjDeptHeaderTyps = [
  { id: 'sales', name: '매출액' },
  { id: 'profitPrice', name: '매출이익' },
];

export const prjOrderHeaderTyps = [
  { id: 'sales', name: '매출액' },
  { id: 'colProfit', name: '협업이익' },
  { id: 'colPrice', name: '협업비용' },
  { id: 'profitPrice', name: '매출이익' },
];

export const prjDeptCountHeaders = [
  { id: 'H', name: 'High', val: 'H' },
  { id: 'M', name: 'Middle', val: 'M' },
  { id: 'L', name: 'Low', val: 'L' },
];

// "포캐스팅 등록 건수" → "포캐스팅 등록 현황"(수주 여부 무관, 2026-10-23, 기획서 4/11).
// 본부/팀별 프로젝트(N)/유지보수(M)/합계 타입별 건수·총금액(매출액)·이익금(매출이익).
export const prjDeptCountTypeHeaders = [
  { id: 'N', name: '프로젝트', val: 'N' },
  { id: 'M', name: '유지보수', val: 'M' },
  { id: 'total', name: '합계', val: 'total' },
];

export const prjDeptCountAmountTyps = [
  { id: 'count', name: '건수' },
  { id: 'amount', name: '총금액' },
  { id: 'profit', name: '이익금' },
];

export const smHeaderTyps = [
  { id: 'sales', name: '매출액' },
  { id: 'profitPrice', name: '매출이익' },
];
export const smHeaders = [
  { id: 'SG', name: '영업목표', val: 'SG' },
  { id: 'SP', name: '연 예상 매출 실적', val: 'SP' },
];

export const salesHeaderTyps1 = [
  { id: 'sales', name: '매출액' },
  { id: 'profitPrice', name: '매출이익' },
];
export const salesHeaderTyps2 = [
  { id: 'sales', name: '매출액' },
  { id: 'salesRate', name: '목표달성률' },
  { id: 'profitPrice', name: '매출이익' },
  { id: 'achiveRate', name: '목표달성률' },
];
export const salesHeaders = [
  { id: 'sg', name: '영업목표', val: 'sg' },
  { id: 'sp', name: '연 예상 매출 실적', val: 'sp' },
  { id: 'tax', name: '세금계산서 실적', val: 'tax' },
  { id: 'ord', name: '수주금액(세금계산서 미발행)', val: 'ord' },
  { id: 'chance', name: '포캐스팅(H/M 이상)', val: 'chance' },
];

export const hqData = [
  {
    id: '1',
    name: '인프라영업본부',
    rowSpan: 1,
  },
  {
    id: '2',
    name: '채널영업본부',
    rowSpan: 1,
  },
  {
    id: '3',
    name: 'NI영업본부',
    rowSpan: 1,
  },
  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
  },
];

export const teamData = [
  {
    id: '1',
    name: '인프라영업본부',
    rowSpan: 5,
    children: [
      { id: '1-1', name: '고객영업1팀' },
      { id: '1-2', name: '고객영업2팀' },
      { id: '1-3', name: '고객영업3팀' },
      { id: '1-4', name: '고객영업4팀' },
      {
        id: 'subTotal',
        name: '소계',
      },
    ],
  },
  {
    id: '2',
    name: '채널영업본부',
    rowSpan: 2,
    children: [
      { id: '2-1', name: '채널영업팀' },
      {
        id: 'subTotal',
        name: '소계',
      },
    ],
  },
  {
    id: '3',
    name: 'NI영업본부',
    rowSpan: 2,
    children: [
      { id: '2-1', name: 'NI영업팀' },
      {
        id: 'subTotal',
        name: '소계',
      },
    ],
  },
  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [{ id: 'total', name: '합계' }],
  },
];

export const teamEmpData = [
  {
    id: '1',
    name: '전략사업본부',
    rowSpan: 9,
    children: [
      {
        id: '1-1',
        name: '전략사업1팀',
        rowSpan: 3,
        children: [
          { id: '1-1-1', name: '직원07 부장' },
          { id: '1-1-2', name: '직원18 차장' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
      {
        id: '1-2',
        name: '전략사업2팀',
        rowSpan: 4,
        children: [
          { id: '1-2-1', name: '직원31 이사' },
          { id: '1-2-2', name: '직원30 전무' },
          { id: '1-2-3', name: '직원11 차장' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
      {
        id: '1-3',
        name: '전략사업3팀',
        rowSpan: 2,
        children: [
          { id: '1-3-1', name: '직원17 이사' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
    ],
  },
  {
    id: '2',
    name: 'SI사업본부',
    rowSpan: 2,
    children: [
      {
        id: '2-1',
        name: 'SI사업본부 본부총괄',
        rowSpan: 2,
        children: [
          { id: '2-1-1', name: '직원27 이사' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
    ],
  },

  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [
      {
        id: 'total',
        name: '합계',
        rowSpan: 1,
        children: [{ id: 'total', name: '합계' }],
      },
    ],
  },
];

export const makeDataPrjHeadquarterStat = () => {
  hqData.map((hq) => {
    return prjDeptHeaders.map((imp) => {
      let priceData = {
        sales: `${Math.floor(Math.random() * 1000000000)}`, //매출액
        profitPrice: `${Math.floor(Math.random() * 1000000000)}`, //매출이익
      };

      // 수주
      if (imp.val === 'OA') {
        priceData.colProfit = `${Math.floor(Math.random() * 1000000000)}`;
        priceData.colPrice = `${Math.floor(Math.random() * 1000000000)}`;
      }

      hq[imp.val] = priceData;
    });
  });
  return Array.from(hqData);
};

export const makeDataPrjDeptStat = () => {
  teamData.map((hq) => {
    return hq.children.map((team) => {
      return prjDeptHeaders.map((imp) => {
        let priceData = {
          sales: `${Math.floor(Math.random() * 1000000000)}`,
          profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
        };
        team[imp.val] = priceData;
      });
    });
  });
  return Array.from(teamData);
};

export const makeDataPrjEmpStat = () => {
  teamEmpData.map((hq) => {
    return hq.children.map((team) => {
      return team.children.map((emp) => {
        return prjDeptHeaders.map((imp) => {
          let priceData = {
            sales: `${Math.floor(Math.random() * 1000000000)}`,
            profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
          };
          emp[imp.val] = priceData;
        });
      });
    });
  });
  return Array.from(teamEmpData);
};

export const makeDataPrjDeptCount = () => {
  teamData.map((hq) => {
    return hq.children.map((team) => {
      return prjDeptCountHeaders.map((imp) => {
        team[imp.val] = `${Math.floor(Math.random() * 100)}`;
      });
    });
  });
  return Array.from(teamData);
};

export const makeDataSMStat = () => {
  teamEmpData.map((hq) => {
    return hq.children.map((team) => {
      return team?.children?.map((emp) => {
        return smHeaders.map((imp) => {
          let priceData = {
            sales: `${Math.floor(Math.random() * 1000000000)}`,
            profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
          };
          emp[imp.val] = priceData;
        });
      });
    });
  });
  return Array.from(teamEmpData);
};

export const makeHqSalesStatics = () => {
  hqData.map((hq) => {
    return salesHeaders.map((imp) => {
      let priceData = {
        sales: `${Math.floor(Math.random() * 1000000000)}`,
        profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
      };

      // 연 예상 매출 실적의 경우
      if (imp.val === 'sp') {
        priceData.salesRate = `${Math.floor(Math.random() * 100)}`;
        priceData.achiveRate = `${Math.floor(Math.random() * 100)}`;
      }

      hq[imp.val] = priceData;
    });
  });
  return Array.from(hqData);
};

export const makeTeamDataSalesStatic = () => {
  teamData.map((hq) => {
    return hq.children.map((team) => {
      return salesHeaders.map((imp) => {
        let priceData = {
          sales: `${Math.floor(Math.random() * 1000000000)}`,
          profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
        };
        // 연 예상 매출 실적의 경우
        if (imp.val === 'sp') {
          priceData.achiveRate = `${Math.floor(Math.random() * 100)}`;
        }

        team[imp.val] = priceData;
      });
    });
  });
  return Array.from(teamData);
};

export const makeEmpDataSalesStatic = () => {
  teamEmpData.map((hq) => {
    return hq.children.map((team) => {
      return team?.children?.map((emp) => {
        return salesHeaders.map((imp) => {
          let priceData = {
            sales: `${Math.floor(Math.random() * 1000000000)}`,
            profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
          };

          // 연 예상 매출 실적의 경우
          if (imp.val === 'sp') {
            priceData['achiveRate'] = `${Math.floor(Math.random() * 100)}`;
          }

          emp[imp.val] = priceData;
        });
      });
    });
  });
  return Array.from(teamEmpData);
};
